import { extractData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import { EventSchema } from "./schemas";
import type { EventType } from "./types";

export const mapDtoToEvent = (dto: unknown): EventType => {
  const parsed = safeParseWithFallback(EventSchema, dto, "mapDtoToEvent");

  return extractData(parsed, dto, dto as EventType);
};
